import { render } from "./SettingsManager.vue?vue&type=template&id=318094ee"
import script from "./SettingsManager.vue?vue&type=script&lang=js"
export * from "./SettingsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__